import React from 'react'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'
import { Data } from '@yy/one-icon'

import { withRedirect } from '@/components/Authorization'
import { Redirect } from 'react-router-dom'

const routes: RouteConfig[] = [
  {
    name: 'dataAnalysis',
    menuTitle: 'common.dataAnalysis',
    path: '/dataAnalysis',
    component: withRedirect(Blank),
    icon: <Data />,
    authCode: 'dataAnalysis',
    routes: [
      {
        menuTitle: 'dataAnalysis.inventoryTurnover.title',
        component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/InventoryTurnover')),
        path: '/inventoryTurnover',
        exact: true,
      },
      {
        menuTitle: 'dataAnalysis.storageStatistics.title',
        component: withAsync(() => import(/* webpackChunkName: "StorageStatistics" */ '@/containers/DataAnalysis/InboundStatistics')),
        path: '/inboundStatistics',
        exact: true,
      },
      {
        menuTitle: 'dataAnalysis.outboundStatistics.title',
        component: withAsync(() => import(/* webpackChunkName: "OutboundStatistics" */ '@/containers/DataAnalysis/OutboundStatistics')),
        path: '/outboundStatistics',
        exact: true,
      },
      {
        menuTitle: 'dataAnalysis.inventoryStatistics.title',
        component: withAsync(() => import(/* webpackChunkName: "InventoryStatistics" */ '@/containers/DataAnalysis/InventoryStatistics')),
        path: '/inventoryStatistics',
        exact: true,
      },
      {
        menuTitle: 'dataAnalysis.goodStatistic.title',
        // component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/GoodStatistic')),
        path: '/goodStatistics',
        exact: true,

        component() {
          return <Redirect to="/dataAnalysis/goodStatistics/all" />
        },
      },
      {
        menuTitle: 'dataAnalysis.goodStatistic.title',
        component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/GoodStatistic')),
        path: '/goodStatistics/:type?',
        exact: true,
        hideInMenu: true,
      },
      {
        menuTitle: 'dataAnalysis.saleAnalysis.title',
        component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/SaleAnalysis')),
        path: '/saleAnalysis',
        exact: true,
      },
      {
        menuTitle: 'dataAnalysis.logisticsAnalysis.title',
        component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/LogisticsAnalysis')),
        path: '/logisticsAnalysis',
        exact: true,
      },
    ],
  },
]

export default routes
